var ObjectHasOwnProperty = Object.hasOwnProperty;
module.exports = function (obj, name) {
  return ObjectHasOwnProperty.call(obj, name);
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex/src/hasOwn.js
// module id = 110
// module chunks = 0